// src/components/financial/FinancialReports.js
import React from 'react';

function FinancialReports({ financialData, expenses, payments, month, year }) {
  const generateCSV = () => {
    const monthName = new Date(year, month - 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    
    let csvContent = `Financial Report - ${monthName}\n\n`;
    csvContent += "SUMMARY\n";
    csvContent += `Total Collected,₹${financialData.totalCollected}\n`;
    csvContent += `Total Expenses,₹${financialData.totalExpenses}\n`;
    csvContent += `Current Balance,₹${financialData.currentBalance}\n`;
    csvContent += `Pending Dues,₹${financialData.pendingDues}\n\n`;
    
    csvContent += "INCOME DETAILS\n";
    csvContent += "Date,Flat,Amount,Method\n";
    payments.forEach(p => {
      csvContent += `${p.payment_date},${p.flat_number},₹${p.amount},${p.payment_method}\n`;
    });
    
    csvContent += "\nEXPENSE DETAILS\n";
    csvContent += "Date,Category,Description,Amount\n";
    expenses.forEach(e => {
      csvContent += `${e.expense_date},${e.expense_categories?.name},${e.title},₹${e.amount}\n`;
    });

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Financial_Report_${month}_${year}.csv`;
    a.click();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3>Financial Reports</h3>
        <button
          onClick={generateCSV}
          style={{
            padding: '10px 20px',
            background: '#17a2b8',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: '600'
          }}
        >
          📥 Download CSV
        </button>
      </div>

      {/* Monthly Summary Report */}
      <div style={{
        background: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h4 style={{ marginBottom: '15px' }}>
          Monthly Summary - {new Date(year, month - 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
        </h4>
        
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6' }}>
                <strong>Opening Balance</strong>
              </td>
              <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6', textAlign: 'right' }}>
                ₹0.00
              </td>
            </tr>
            <tr>
              <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6' }}>
                <strong>Total Collections</strong>
              </td>
              <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6', textAlign: 'right', color: '#28a745' }}>
                +₹{financialData.totalCollected.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6' }}>
                <strong>Total Expenses</strong>
              </td>
              <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6', textAlign: 'right', color: '#dc3545' }}>
                -₹{financialData.totalExpenses.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td style={{ padding: '10px', borderBottom: '2px solid #333' }}>
                <strong>Closing Balance</strong>
              </td>
              <td style={{ 
                padding: '10px', 
                borderBottom: '2px solid #333', 
                textAlign: 'right',
                fontSize: '18px',
                fontWeight: 'bold',
                color: financialData.currentBalance >= 0 ? '#28a745' : '#dc3545'
              }}>
                ₹{financialData.currentBalance.toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Collection Status */}
      <div style={{
        background: '#e8f5e9',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h4 style={{ marginBottom: '15px', color: '#2e7d32' }}>Collection Status</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          <div>
            <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Collected</div>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#2e7d32' }}>
              ₹{financialData.totalCollected.toFixed(2)}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Pending</div>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#f57c00' }}>
              ₹{financialData.pendingDues.toFixed(2)}
            </div>
          </div>
        </div>
        
        {/* Collection Progress Bar */}
        <div style={{ marginTop: '15px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
            <span style={{ fontSize: '12px', color: '#666' }}>Collection Progress</span>
            <span style={{ fontSize: '12px', color: '#666' }}>
              {((financialData.totalCollected / (financialData.totalCollected + financialData.pendingDues)) * 100).toFixed(1)}%
            </span>
          </div>
          <div style={{
            height: '20px',
            background: '#c8e6c9',
            borderRadius: '10px',
            overflow: 'hidden'
          }}>
            <div style={{
              height: '100%',
              width: `${(financialData.totalCollected / (financialData.totalCollected + financialData.pendingDues)) * 100}%`,
              background: '#4caf50',
              transition: 'width 0.3s ease'
            }}></div>
          </div>
        </div>
      </div>

      {/* Important Notes */}
      <div style={{
        background: '#fff3cd',
        padding: '15px',
        borderRadius: '8px',
        borderLeft: '4px solid #ffc107'
      }}>
        <h5 style={{ marginBottom: '10px', color: '#856404' }}>📌 Important Notes</h5>
        <ul style={{ margin: 0, paddingLeft: '20px', color: '#856404', fontSize: '14px' }}>
          <li>This report is generated based on recorded transactions only</li>
          <li>Pending dues are calculated based on active residents</li>
          <li>For detailed vendor information, contact the admin</li>
          <li>All amounts are in Indian Rupees (₹)</li>
        </ul>
      </div>
    </div>
  );
}

export default FinancialReports;